var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "createTrip"
  }, [_c('Loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), (_vm.isawbvalid) ? _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Make FTC Payment")])])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "makeFTC"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("AWB:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.AWB))]), _vm._v(" "), _c('th', [_vm._v("Total number of MPS:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NoofMPS))]), _vm._v(" "), _c('th', [_vm._v("Origin City (Hub):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.origincity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Destination City (Hub):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.destinationcity))]), _vm._v(" "), _c('th', [_vm._v("Pick Up Date :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pickupdate))]), _vm._v(" "), _c('th', [_vm._v("RAD Date:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.raddate))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Consignor Name and Address")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "consignordetails"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Address Line 1:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consignoraddress1))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Address Line 2:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consignoraddress2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.origincity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pincode:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pickuppincode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("State:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pickupstate))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Consignee Name and Address")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "consigneedetails"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Address Line 1:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consigneeaddress1))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Address Line 2:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.consigneeaddress2))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("City:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.destinationcity))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Pincode:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.destinationpincode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("State:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.destinationstate))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-2"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("A + B + C + D")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-badge', {
    attrs: {
      "variant": "warn_info"
    }
  }, [_vm._v("Total FTC Amount (INR) :"), _c('span', [_vm._v(" " + _vm._s(Number(_vm.ftctotalamtwogst).toFixed(2).toLocaleString()))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-2"
  }, [_c('div', {
    staticClass: "col-md-2 mt-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("A + B + C + D + E")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6 mt-2"
  }, [(!_vm.isTDSApplcable) ? _c('b-badge', {
    attrs: {
      "variant": "warn_info"
    }
  }, [_vm._v("\n          Total FTC Amount (INR) (Including GST):"), _c('span', [_vm._v(" " + _vm._s(Number(_vm.totalFTCamount).toFixed(2)))])]) : _vm._e(), _vm._v(" "), (_vm.isTDSApplcable) ? _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          Total FTC Amount (INR) (Including GST):"), _c('span', [_vm._v(" " + _vm._s(Number(_vm.amountBeforeTdsDeduction).toFixed(2)))])]) : _vm._e(), _vm._v(" "), (_vm.isTDSApplcable) ? _c('b-badge', {
    attrs: {
      "variant": "warn_info"
    }
  }, [_vm._v("\n            Total FTC Amount (INR) (After TDS Deduction):"), _c('span', [_vm._v(" " + _vm._s(Number(_vm.totalFTCamount).toFixed(2)))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-top": "0px",
      "float": "right"
    },
    attrs: {
      "disabled": !this.paymentlink,
      "type": "button"
    },
    on: {
      "click": _vm.openPaymentLink
    }
  }, [_vm._v("\n          Proceed to Payment\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-auto"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "AssignedBA/SR",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("A. Freight Charges (" + _vm._s(Number(_vm.totalfreightcharges).toFixed(2).toLocaleString()) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Weights")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "freightcharge"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "60%"
    }
  }, [_vm._v("W1. Volumetric Weight (kg):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.freightChargesData.volumetricweight))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "60%"
    }
  }, [_vm._v("W2. Physical Weight (kg):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.freightChargesData.physicalweight))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                          W3. Applicable Weight (kg):"), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "font-style": "italic"
    }
  }, [_vm._v("(Max of 1 and 2)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.freightChargesData.applicableweight))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("W4. Minimum Chargeable Weight (kg):")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.freightChargesData.minimumChargeableweight) + "\n                        ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                          W5. Bill Weight (kg):"), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "font-style": "italic"
    }
  }, [_vm._v("(Max of W3 and W4)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.freightChargesData.billWeight))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Charge Calculation")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "height": "167px"
    },
    attrs: {
      "id": "chargecal"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "70%"
    }
  }, [_vm._v("\n                          C1. Freight rate for the lane (INR per kg):\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.freightChargesData.freightRateperKG))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "70%"
    }
  }, [_vm._v("\n                          C2. Freight Charges (INR): "), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "font-style": "italic"
    }
  }, [_vm._v("(Higher of \"C1 x W5\" or Minimum Docket Amount)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.freightChargesData.freightCharges))])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("B. Insurance Charges (" + _vm._s(Number(_vm.totalinsurancecharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "insurancecharge"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "37%"
    }
  }, [_vm._v("Applicable charge:")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.insurancechargesData.applicableCharge))]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "28%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.insurancechargesData.applicableCharge) + " Charge\n                          Type:\n                        ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.FOVchargetype))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.insurancechargesData.applicableCharge) + " % type")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.fovtype))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.insurancechargesData.applicableCharge) + " Rate (%):")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.fovrate))]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Limits (" + _vm._s(_vm.insurancechargesData.applicableCharge) + " Charges) (INR)")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Min")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.min))]), _vm._v(" "), _c('th', [_vm._v("Max")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.max))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Charge Calculation")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "height": "133px"
    },
    attrs: {
      "id": "chargescal"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("Invoice Value (INR):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.invoicevalue))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.insurancechargesData.applicableCharge) + " Charges (INR) : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.fovCharges))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v(_vm._s(_vm.insurancechargesData.applicableCharge) + " Charges payable (INR) : ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.insurancechargesData.fovPayable))])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("C. Accessorial Charges (" + _vm._s(Number(_vm.totalaccessorialCharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "AccessorialCharges"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Waybill Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.waybillcharges))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "27%"
    }
  }, [_vm._v("\n                          Appointment/ Different Vehicle Charges:\n                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.vehiclecharges))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("RTO Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.rto))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("DC Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.dcCharges))]), _vm._v(" "), _c('th', [_vm._v("Loading/Unloading Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.waybillcharges))]), _vm._v(" "), _c('th', [_vm._v("ODA charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.oda))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("FTC (To Pay) Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.fodcharges))]), _vm._v(" "), _c('th', [_vm._v("Loading/Unloading Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.waybillcharges))]), _vm._v(" "), _c('th', [_vm._v("Holiday delivery charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.holidaycharges))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fuel Surcharge:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.fuelsurcharge))]), _vm._v(" "), _c('th', [_vm._v("Handling Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.handlingcharges))]), _vm._v(" "), _c('th', [_vm._v("Open pickup/delivery charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.openpickup))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Delivery Attempt Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.deliveryattempt))]), _vm._v(" "), _c('th', [_vm._v("Delivery above ground floor charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.groundfloorcharges))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Demurrage Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.demurrage))]), _vm._v(" "), _c('th', [_vm._v("Green Tax:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.accessorialchargesData.greentax))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("D. AWB Extra Charges (" + _vm._s(Number(_vm.totalawbextracharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "awbextracharges"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Odd Size Shipments Charges (>100 Kg/MPS):")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.shipmentsized))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "27%"
    }
  }, [_vm._v("Mathadi/Varai/Union Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.mathadi))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Open Pick-up/Delivery Charges Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.portgages))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Appointment/CSD/Mall Delivery Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.specialdelivery))]), _vm._v(" "), _c('th', [_vm._v("Floor Pick-up/Delivery Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.loadingunloading))]), _vm._v(" "), _c('th', [_vm._v("ODA Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.oda))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Other Charges:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.awbExtraChargesData.fulltruckload))])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck5"
    }
  }, [_vm._v("E. GST " + _vm._s(_vm.gst) + "% (" + _vm._s(Number((_vm.ftctotalamtwogst / 100) * _vm.gst).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "gst"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("GST " + _vm._s(_vm.gst) + "% :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((_vm.ftctotalamtwogst / 100) * _vm.gst).toFixed(2)))])])])])])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isawbvalid) ? _c('b-card', [_c('center', [_c('b', [_vm._v("This payment link has expired. Please use new link that will be sent in a separate email.")])])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0496525c","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/makeFTCPayment/makeFTCPayment.component.html
// module id = 1889
// module chunks = 3